<template>
  <a-form @submit="handleSubmit" :form="form" class="form">
    <a-form-item
      v-show="false"
      label="id"
    >
      <a-input
        v-decorator="['id']"
      />
    </a-form-item>
    <a-row class="form-row" :gutter="16">
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item label="工程名称">
          <a-input
            placeholder="请输入工程名称"
            :disabled="showable"
            v-decorator="[
              'projectName',
              {rules: [{ required: true, message: '请输入工程名称', whitespace: true}]}
            ]" />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 7, offset: 1}" :lg="{span: 8}" :md="{span: 12}" :sm="24">
        <a-form-item
          label="合同工程名称">
          <a-input
            placeholder="请输入"
            :disabled="showable"
            v-decorator="[
              'projectContractName',
              {rules: [{ required: true, message: '请输入合同工程名称', whitespace: true}]}
            ]" />
        </a-form-item>
      </a-col>
      <a-col :xl="{span: 7, offset: 1}" :lg="{span: 8}" :md="{span: 12}" :sm="24">
        <a-form-item
          label="项目经理">
          <a-input
            placeholder="请输入"
            :disabled="showable"
            v-decorator="[
              'projectContractManager',
              {rules: [{ required: true, message: '请输入项目经理', whitespace: true}]}
            ]" />
        </a-form-item>
      </a-col>
      <a-col :lg="6" :md="12" :sm="24">
        <a-form-item
          label="工程建立时间">
          <a-date-picker
            style="width: 100%"
            :disabled="showable"
            format="YYYY-MM-DD"
            v-decorator="[
              'projectBuildDate',
              {rules: [{ required: true, message: '请选择日期'}]}
            ]"></a-date-picker>
        </a-form-item>
      </a-col>
    </a-row>
    <a-form-item v-if="showSubmit">
      <a-button htmlType="submit" >Submit</a-button>
    </a-form-item>
  </a-form>
</template>

<script>
import pick from 'lodash.pick'
import moment from 'moment'
export default {
  name: 'ProjectInfoForm',
  props: {
    showSubmit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      showable: false,
      addable: false,
      editable: false,
      managerList: [],
      form: this.$form.createForm(this)
    }
  },
  methods: {
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          this.$notification['error']({
            message: 'Received values of form:',
            description: values
          })
        }
      })
    },
    loadData (data, type) {
      this.visible = true
      if (type && type === 'add') {
        this.addable = true
        this.showable = false
        this.type = type
      }
      if (type === 'edit') {
        this.editable = true
        this.showable = false
        this.type = type
      }
      if (type === 'show') {
        this.showable = true
        this.type = type
      }
      const { form: { setFieldsValue, resetFields } } = this
      if (['edit', 'show'].includes(type)) {
        this.confirmLoading = true
        const record = data
        if (record.projectBuildDate) {
          record.projectBuildDate = moment(record.projectBuildDate, 'YYYY-MM-DD')
        }
        this.confirmLoading = false
        this.$nextTick(() => {
          setFieldsValue(pick(record, [
            'id',
            'projectName',
            'projectContractName',
            'projectContractManager',
            'projectBuildDate'
          ]))
        })
      } else {
        resetFields()
      }
    }
  }
}
</script>

<style scoped>

</style>
